import { WaterInvoiceApproveStatus } from "../enums/global.enums";

export function waterInvoiceApproveStatusPipe(status: string): string {
    switch (status) {
      case WaterInvoiceApproveStatus.All:
        return "Tất cả";
      case WaterInvoiceApproveStatus.NotApprove:
        return "Chờ phê duyệt";
      case WaterInvoiceApproveStatus.Approved:
        return "Phê duyệt";
      default:
        return "";
    }
  }